/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { useState } from 'react';

import { ChevronDown } from '@td-client-frontend/icons';

const Sorting = ({ type, handleSorting }) => {
  const [typeSorting, setTypeSorting] = useState(type);

  const onClickDown = () => {
    setTypeSorting('DESC');
    handleSorting('DESC');
  };

  const onClickUp = () => {
    setTypeSorting('ASC');
    handleSorting('ASC');
  };

  return (
    <>
      {typeSorting === 'ASC' && (
        <ChevronDown className="ml-2 cursor-pointer" style={{ marginTop: '3px' }} onClick={onClickDown} />
      )}
      {typeSorting === 'DESC' && (
        <ChevronDown
          transform="rotate(180)"
          className="ml-2 cursor-pointer"
          style={{ marginTop: '3px' }}
          onClick={onClickUp}
        />
      )}
    </>
  );
};

export default Sorting;
